import { useMemo } from 'preact/hooks'
import { hasOwnProperties } from 'helpers/utils'
import ProductVariantText from 'snippets/product/product-variant/product-variant-text'
import ProductVariantColour from 'snippets/product/product-variant/product-variant-colour'

const selectors = {
  COLOUR_KEYS: ['Colours', 'Colors']
}

function ProductVariantItem({ value, option, selected, selectableValues, setSelected }) {
  const isColour = useMemo(() => selectors.COLOUR_KEYS.includes(option), [option])

  const isSelected = useMemo(
    () => hasOwnProperties(option, selected) && selected[option] === value,
    [option, selected, value]
  )

  const isDisabled = useMemo(
    () => hasOwnProperties(option, selectableValues) && !selectableValues[option]?.includes(value),
    [option, selectableValues, value]
  )

  const onSelect = (newValue, newOption) => {
    const updatedSelected = { ...selected, [newOption]: newValue }

    setSelected(updatedSelected)
  }

  return isColour ? (
    <ProductVariantColour
      value={value}
      option={option}
      onSelect={onSelect}
      isSelected={isSelected}
      isDisabled={isDisabled}
    />
  ) : (
    <ProductVariantText
      value={value}
      option={option}
      onSelect={onSelect}
      isSelected={isSelected}
      isDisabled={isDisabled}
    />
  )
}

export default ProductVariantItem
